(() => {


  window.__BMDOptionAProductCache = window.__BMDOptionAProductCache || new Map();
  window.__BMDOptionAState = window.__BMDOptionAState || new Map();

  const cache = window.__BMDOptionAProductCache;
  const stateStore = window.__BMDOptionAState;
  let editor = null;
  let activeRoot = null;
  let editingShirt = null;
  let draft = null;
  let warmedCatalogKey = "";

  const getDesigns = (root = activeRoot) => {
    if (!root) return [];
    if (Array.isArray(root.__bmdBundleDesigns)) return root.__bmdBundleDesigns;

    const source = root.querySelector("[data-bmd-bundle-designs]");
    try {
      const parsed = JSON.parse(source?.textContent || "[]");
      root.__bmdBundleDesigns = Array.isArray(parsed)
        ? parsed.filter((item) => item && item.handle && item.title)
        : [];
    } catch {
      root.__bmdBundleDesigns = [];
    }

    return root.__bmdBundleDesigns;
  };

  const thumb = (url, width = 120) => {
    if (!url) return "";
    if (url.includes("width=")) return url;
    return url + (url.includes("?") ? "&" : "?") + "width=" + width;
  };

  const normalizeProduct = (raw) => {
    const variants = (raw.variants || []).map((v) => ({
      id: String(v.id),
      color: String(v.option1 || v.options?.[0] || ""),
      size: String(v.option2 || v.options?.[1] || ""),
      price: Number(v.price) || 0,
      available: Boolean(v.available),
      image: thumb(
        typeof v.featured_image === "string"
          ? v.featured_image
          : v.featured_image?.src || v.featured_image?.url ||
            (typeof raw.featured_image === "string"
              ? raw.featured_image
              : raw.featured_image?.src || raw.images?.[0] || ""),
        120
      )
    }));

    const seen = new Set();
    const colors = [];
    variants.forEach((v) => {
      if (!v.available || !v.color || seen.has(v.color)) return;
      seen.add(v.color);
      const rep = variants.find((x) => x.available && x.color === v.color && x.image) || v;
      colors.push({ name: v.color, image: rep.image || "" });
    });

    return {
      handle: raw.handle,
      title: raw.title,
      image: thumb(
        typeof raw.featured_image === "string"
          ? raw.featured_image
          : raw.featured_image?.src || raw.images?.[0] || "",
        320
      ),
      variants,
      colors
    };
  };

  const loadProduct = (handle) => {
    if (cache.has(handle)) return cache.get(handle);
    const rootPath = window.Shopify?.routes?.root || "/";
    const base = rootPath.endsWith("/") ? rootPath : rootPath + "/";
    const promise = fetch(base + "products/" + encodeURIComponent(handle) + ".js", {
      headers: { Accept: "application/json" }
    })
      .then((r) => {
        if (!r.ok) throw new Error("Product load failed");
        return r.json();
      })
      .then(normalizeProduct)
      .catch((error) => {
        cache.delete(handle);
        throw error;
      });

    cache.set(handle, promise);
    return promise;
  };

  const warmCatalog = (root = activeRoot) => {
    const designs = getDesigns(root);
    const key = designs.map((d) => d.handle).join("|");
    if (!designs.length || warmedCatalogKey === key) return;

    warmedCatalogKey = key;
    const queue = designs.map((d) => d.handle);
    let index = 0;
    const worker = async () => {
      while (index < queue.length) {
        const handle = queue[index++];
        try { await loadProduct(handle); } catch {}
      }
    };
    Promise.allSettled([worker(), worker(), worker()]);
  };

  const preloadColorImages = (product) => {
    (product?.colors || []).forEach((option) => {
      if (!option.image) return;
      const img = new Image();
      img.decoding = "async";
      img.src = option.image;
    });
  };

  const ensureEditor = () => {
    if (editor?.isConnected) return editor;
    const wrap = document.createElement("div");
    wrap.innerHTML = `
      <div class="bmd-extra-editor" data-bmd-extra-editor hidden role="dialog" aria-modal="true" aria-labelledby="bmd-extra-editor-title">
        <button type="button" class="bmd-extra-editor__backdrop" data-bmd-editor-close aria-label="Close"></button>
        <div class="bmd-extra-editor__panel">
          <div class="bmd-extra-editor__header">
            <div>
              <strong id="bmd-extra-editor-title" data-bmd-editor-title>Choose Shirt 2</strong>
              <span>Pick a design, then color and size.</span>
            </div>
            <button type="button" class="bmd-extra-editor__close" data-bmd-editor-close aria-label="Close">×</button>
          </div>
          <div class="bmd-extra-step">
            <div class="bmd-extra-step__heading"><strong>1. Design</strong><span>Scroll sideways</span></div>
            <div class="bmd-design-strip" data-bmd-design-strip></div>
          </div>
          <div class="bmd-extra-step">
            <div class="bmd-extra-step__heading"><strong>2. Color</strong><span data-bmd-color-help>Choose a design first</span></div>
            <div class="bmd-color-strip" data-bmd-color-strip><span class="bmd-placeholder">Color choices appear here</span></div>
          </div>
          <div class="bmd-extra-step">
            <div class="bmd-extra-step__heading"><strong>3. Size</strong></div>
            <div class="bmd-size-row" data-bmd-size-row><span class="bmd-placeholder">Choose a color first</span></div>
          </div>
          <div class="bmd-extra-editor__footer">
            <button type="button" class="bmd-editor-cancel" data-bmd-editor-close>Cancel</button>
            <button type="button" class="bmd-editor-save" data-bmd-editor-save disabled>Save Shirt</button>
          </div>
        </div>
      </div>`;
    editor = wrap.firstElementChild;
    document.body.appendChild(editor);
    editor.querySelectorAll("[data-bmd-editor-close]").forEach((b) => b.addEventListener("click", closeEditor));
    editor.querySelector("[data-bmd-editor-save]").addEventListener("click", saveEditor);
    return editor;
  };

  const getStateKey = (root) => root.dataset.currentProductHandle || location.pathname;
  const getState = (root) => {
    const key = getStateKey(root);
    if (!stateStore.has(key)) {
      stateStore.set(key, {
        qty: 1,
        extras: {
          2: { product:"", title:"", color:"", size:"", variantId:"", price:0, image:"" },
          3: { product:"", title:"", color:"", size:"", variantId:"", price:0, image:"" }
        }
      });
    }
    return stateStore.get(key);
  };

  const money = (root, cents) => new Intl.NumberFormat(document.documentElement.lang || "en-US", {
    style: "currency",
    currency: root.dataset.currency || "USD"
  }).format((Number(cents) || 0) / 100);

  const row = (root, n) => root.querySelector('[data-bmd-extra-shirt="' + n + '"]');
  const rowField = (root, n, selector) => row(root, n)?.querySelector(selector);

  const renderExtraRow = (root, n, extra) => {
    const r = row(root, n);
    if (!r) return;
    const summary = r.querySelector("[data-bmd-extra-summary]");
    const action = r.querySelector("[data-bmd-edit-extra]");
    const thumbEl = r.querySelector("[data-bmd-extra-thumb]");
    const imageEl = r.querySelector("[data-bmd-extra-image]");

    if (extra.variantId) {
      summary.textContent = extra.title + " · " + extra.color + " / " + extra.size;
      action.textContent = "Edit";
      if (extra.image) {
        imageEl.src = extra.image;
        imageEl.alt = extra.title + " — " + extra.color;
        thumbEl.hidden = false;
      }
    } else {
      summary.textContent = "Choose another design, color and size";
      action.textContent = "Choose";
      thumbEl.hidden = true;
      imageEl.removeAttribute("src");
    }

    const values = {
      "[data-bmd-shirt-variant]": extra.variantId,
      "[data-bmd-extra-product]": extra.product,
      "[data-bmd-extra-title]": extra.title,
      "[data-bmd-extra-color]": extra.color,
      "[data-bmd-extra-size]": extra.size,
      "[data-bmd-extra-price]": extra.price ? String(extra.price) : "",
      "[data-bmd-extra-image-url]": extra.image
    };
    Object.entries(values).forEach(([selector,value]) => {
      const input = r.querySelector(selector);
      if (input) input.value = value || "";
    });
  };

  const updatePricing = (root) => {
    const state = getState(root);
    const primaryPrice = Number(root.dataset.primaryPrice) || 3399;
    const e2 = state.extras[2];
    const e3 = state.extras[3];

    const one = root.querySelector('[data-bmd-total="1"]');
    if (one) one.textContent = money(root, primaryPrice);

    const twoRegular = primaryPrice + (e2.price || 3399);
    const twoTotal = Math.round(twoRegular * .90);
    root.querySelector('[data-bmd-total="2"]').textContent = (e2.variantId ? "" : "From ") + money(root, twoTotal) + " total";
    root.querySelector('[data-bmd-save="2"]').textContent = e2.variantId ? "You save " + money(root, twoRegular - twoTotal) + " + FREE U.S. shipping" : "Save 10% + FREE U.S. shipping";

    const threeRegular = primaryPrice + (e2.price || 3399) + (e3.price || 3399);
    const threeTotal = Math.round(threeRegular * .85);
    root.querySelector('[data-bmd-total="3"]').textContent = (e2.variantId && e3.variantId ? "" : "From ") + money(root, threeTotal) + " total";
    root.querySelector('[data-bmd-save="3"]').textContent = e2.variantId && e3.variantId ? "You save " + money(root, threeRegular - threeTotal) + " + FREE U.S. shipping" : "Save 15% + FREE U.S. shipping";
  };

  // BMD bundle purchase-state fix — 2026-09-28
  const ensureBundleCheckoutNote = (productForm, accelerated) => {
    if (!productForm) return null;
    let note = productForm.querySelector("[data-bmd-bundle-checkout-note]");
    if (!note) {
      note = document.createElement("p");
      note.className = "bmd-bundle-checkout-note";
      note.dataset.bmdBundleCheckoutNote = "true";
      note.textContent = "Shop Pay is available at checkout after adding your bundle to cart.";
      note.hidden = true;
      if (accelerated) accelerated.insertAdjacentElement("afterend", note);
      else productForm.appendChild(note);
    }
    return note;
  };

  const getPrimaryChoiceState = (root) => {
    const productForm = root.closest("product-form-component");
    const details = productForm?.closest(".product-details");
    const picker = details?.querySelector("variant-picker[data-product-id]");
    const fieldsets = Array.from(picker?.querySelectorAll("fieldset.variant-option") || []).filter(
      (fieldset) => fieldset.querySelectorAll("input[type='radio'][data-option-name]").length > 1
    );

    const requiredNames = fieldsets
      .map((fieldset) => fieldset.querySelector("input[data-option-name]")?.dataset.optionName)
      .filter(Boolean);

    const productId = picker?.dataset.productId;
    const chosen = productId ? window.__bmdChosenProductOptions?.get(productId) : null;
    const missingNames = requiredNames.filter((name) => !(chosen instanceof Set) || !chosen.has(name));

    const labelForMissing = () => {
      const names = missingNames.map((name) => String(name).trim().toLowerCase());
      if (names.length === 1) return "Select a " + names[0];
      if (names.length === 2) return "Select " + names[0] + " and " + names[1];
      if (names.length > 2) return "Select required options";
      return "";
    };

    return {
      complete: missingNames.length === 0,
      missingNames,
      lockedText: labelForMissing()
    };
  };

  const syncActions = (root) => {
    const state = getState(root);
    const qty = state.qty;
    const productForm = root.closest("product-form-component");
    const addButton = productForm?.querySelector('[ref="addToCartButton"]');
    const accelerated = productForm?.querySelector('[ref="acceleratedCheckoutButtonContainer"]');
    const checkoutNote = ensureBundleCheckoutNote(productForm, accelerated);
    const primaryAvailable = String(root.dataset.primaryAvailable) !== "false";
    const primaryChoice = getPrimaryChoiceState(root);
    let extrasValid = true;

    [2,3].forEach((n) => {
      const active = n <= qty;
      const extra = state.extras[n];
      const idInput = root.querySelector('[data-bmd-additional-id="' + n + '"]');
      const qInput = root.querySelector('[data-bmd-additional-qty="' + n + '"]');
      const useExtra = active && Boolean(extra.variantId);

      if (idInput) {
        idInput.value = useExtra ? extra.variantId : "";
        idInput.disabled = !useExtra;
        if (useExtra && idInput.dataset.bmdOriginalName) idInput.name = idInput.dataset.bmdOriginalName;
        else idInput.removeAttribute("name");
      }
      if (qInput) {
        qInput.value = "1";
        qInput.disabled = !useExtra;
        if (useExtra && qInput.dataset.bmdOriginalName) qInput.name = qInput.dataset.bmdOriginalName;
        else qInput.removeAttribute("name");
      }
      if (active && !extra.variantId) extrasValid = false;
    });

    const valid = primaryAvailable && primaryChoice.complete && extrasValid;

    if (addButton instanceof HTMLButtonElement) {
      const label = addButton.querySelector(".add-to-cart-text__content span span");
      if (label) {
        if (!addButton.dataset.bmdBundleOriginalText) {
          addButton.dataset.bmdBundleOriginalText = label.textContent.trim() || "Add to cart";
        }

        if (!primaryChoice.complete) {
          label.textContent = primaryChoice.lockedText || "Select product options";
        } else if (!primaryAvailable) {
          label.textContent = "Unavailable";
        } else if (qty > 1 && !state.extras[2].variantId) {
          label.textContent = "Choose Shirt 2";
        } else if (qty > 2 && !state.extras[3].variantId) {
          label.textContent = "Choose Shirt 3";
        } else if (qty > 1) {
          label.textContent = "Add bundle to cart";
        } else {
          label.textContent = addButton.dataset.bmdBundleOriginalText || "Add to cart";
        }
      }

      addButton.disabled = !valid;
      addButton.classList.toggle("bmd-bundle-add-ready", valid);
      addButton.classList.toggle("bmd-bundle-add-incomplete", !valid);

      if (qty > 1) addButton.dataset.bmdBundleManaged = "true";
      else delete addButton.dataset.bmdBundleManaged;
    }

    if (accelerated) {
      const hideAccelerated = qty > 1 || !primaryAvailable || !primaryChoice.complete;
      accelerated.hidden = hideAccelerated;
      accelerated.toggleAttribute("inert", hideAccelerated);
      if (hideAccelerated) accelerated.setAttribute("aria-hidden", "true");
      else accelerated.removeAttribute("aria-hidden");

      if (qty > 1) accelerated.dataset.bmdBundleManaged = "true";
      else delete accelerated.dataset.bmdBundleManaged;
    }

    if (checkoutNote) {
      checkoutNote.hidden = !(qty > 1 && valid);
    }
  };

  const renderRootState = (root) => {
    const state = getState(root);
    root.dataset.bmdBundleQuantity = String(state.qty);
    root.querySelectorAll("[data-bmd-qty]").forEach((b) => {
      const selected = Number(b.dataset.bmdQty) === state.qty;
      b.classList.toggle("is-selected", selected);
      b.setAttribute("aria-checked", selected ? "true" : "false");
    });
    const config = root.querySelector("[data-bmd-bundle-config]");
    if (config) config.hidden = state.qty === 1;
    const r3 = row(root, 3);
    if (r3) r3.hidden = state.qty < 3;
    renderExtraRow(root, 2, state.extras[2]);
    renderExtraRow(root, 3, state.extras[3]);
    updatePricing(root);
    syncActions(root);
  };

  const setQuantity = (root, qty) => {
    const state = getState(root);
    state.qty = qty;
    const productForm = root.closest("product-form-component");
    const quantityInput = productForm?.querySelector('input[name="quantity"]');
    if (quantityInput) quantityInput.value = "1";
    if (qty > 1) warmCatalog(root);
    renderRootState(root);
  };

  const renderDesigns = () => {
    const strip = editor.querySelector("[data-bmd-design-strip]");
    strip.innerHTML = "";
    const designs = getDesigns(activeRoot);

    if (!designs.length) {
      strip.innerHTML = '<span class="bmd-placeholder">No bundle designs are available right now.</span>';
      return;
    }

    const currentHandle = activeRoot?.dataset.currentProductHandle || "";
    const currentDesign = designs.find((design) => design.handle === currentHandle);
    const orderedDesigns = currentDesign
      ? [currentDesign, ...designs.filter((design) => design.handle !== currentHandle)]
      : designs;

    orderedDesigns.forEach((design) => {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "bmd-design-card";
      if (draft?.product === design.handle) b.classList.add("is-selected");

      const wrap = document.createElement("div");
      wrap.className = "bmd-design-card__image";
      const img = document.createElement("img");
      img.src = thumb(design.image, 320);
      img.alt = design.title;
      img.loading = "lazy";
      wrap.appendChild(img);

      const label = document.createElement("span");
      label.textContent = design.title;
      b.append(wrap,label);

      const warm = () => loadProduct(design.handle).then(preloadColorImages).catch(() => {});
      b.addEventListener("pointerenter", warm, {once:true,passive:true});
      b.addEventListener("focus", warm, {once:true});
      b.addEventListener("pointerdown", warm, {once:true,passive:true});
      b.addEventListener("click", () => chooseDesign(design,b));
      strip.appendChild(b);
    });
  };

  const renderColors = (product) => {
    const strip = editor.querySelector("[data-bmd-color-strip]");
    const help = editor.querySelector("[data-bmd-color-help]");
    strip.innerHTML = "";
    product.colors.forEach((option) => {
      const b = document.createElement("button");
      b.type = "button";
      b.className = "bmd-color-card";
      if (draft?.color === option.name) b.classList.add("is-selected");

      const wrap = document.createElement("div");
      wrap.className = "bmd-color-card__image";
      if (option.image) {
        const img = document.createElement("img");
        img.src = option.image;
        img.alt = option.name;
        img.width = 78;
        img.height = 78;
        img.decoding = "async";
        wrap.appendChild(img);
      }

      const label = document.createElement("span");
      label.textContent = option.name;
      b.append(wrap,label);
      b.addEventListener("click", () => chooseColor(product,option.name,b));
      strip.appendChild(b);
    });
    help.textContent = "Scroll sideways for more colors";
  };

  const updateEditorSaveState = () => {
    if (!editor) return;
    const saveButton = editor.querySelector("[data-bmd-editor-save]");
    if (!(saveButton instanceof HTMLButtonElement)) return;

    if (!draft?.product) {
      saveButton.disabled = true;
      saveButton.textContent = "Select a design";
    } else if (!draft?.color) {
      saveButton.disabled = true;
      saveButton.textContent = "Select a color";
    } else if (!draft?.size || !draft?.variantId) {
      saveButton.disabled = true;
      saveButton.textContent = "Select a size";
    } else {
      saveButton.disabled = false;
      saveButton.textContent = "Save Shirt";
    }
  };

  const renderSizes = (product,color) => {
    const sizeRow = editor.querySelector("[data-bmd-size-row]");
    sizeRow.innerHTML = "";
    const order = ["S","M","L","XL","2XL","3XL","4XL"];
    const all = [...new Set(product.variants.map((v) => v.size).filter(Boolean))];
    const sizes = [...order.filter((s) => all.includes(s)), ...all.filter((s) => !order.includes(s))];

    sizes.forEach((size) => {
      const variant = product.variants.find((v) => v.color === color && v.size === size);
      const b = document.createElement("button");
      b.type = "button";
      b.className = "bmd-size-pill";
      b.textContent = size;
      b.disabled = !variant?.available;
      if (draft?.size === size && draft?.variantId === variant?.id) b.classList.add("is-selected");
      if (variant?.available) {
        b.addEventListener("click", () => {
          draft.size = size;
          draft.variantId = variant.id;
          draft.price = variant.price;
          draft.image = variant.image || product.image || "";
          sizeRow.querySelectorAll(".bmd-size-pill").forEach((x) => x.classList.toggle("is-selected",x===b));
          updateEditorSaveState();
        });
      }
      sizeRow.appendChild(b);
    });
  };

  const chooseDesign = async (design,button) => {
    draft = {product:design.handle,title:design.title,color:"",size:"",variantId:"",price:0,image:design.image||""};
    editor.querySelectorAll(".bmd-design-card").forEach((x) => x.classList.toggle("is-selected",x===button));
    editor.querySelector("[data-bmd-color-strip]").innerHTML = '<span class="bmd-placeholder">Loading colors…</span>';
    editor.querySelector("[data-bmd-color-help]").textContent = "Loading colors…";
    editor.querySelector("[data-bmd-size-row]").innerHTML = '<span class="bmd-placeholder">Choose a color first</span>';
    updateEditorSaveState();

    try {
      const product = await loadProduct(design.handle);
      preloadColorImages(product);
      renderColors(product);
    } catch {
      editor.querySelector("[data-bmd-color-strip]").innerHTML = '<span class="bmd-placeholder">Unable to load colors</span>';
      editor.querySelector("[data-bmd-color-help]").textContent = "Try another design";
    }
  };

  const chooseColor = (product,color,button) => {
    draft.color = color;
    draft.size = "";
    draft.variantId = "";
    draft.price = 0;
    draft.image = "";
    editor.querySelectorAll(".bmd-color-card").forEach((x) => x.classList.toggle("is-selected",x===button));
    renderSizes(product,color);
    updateEditorSaveState();
  };

  async function openEditor(root,n) {
    activeRoot = root;
    editingShirt = n;
    ensureEditor();
    const state = getState(root);
    draft = {...state.extras[n]};
    editor.querySelector("[data-bmd-editor-title]").textContent = "Choose Shirt " + n;
    renderDesigns();
    editor.hidden = false;
    document.documentElement.style.overflow = "hidden";
    warmCatalog(root);

    if (draft.product) {
      editor.querySelector("[data-bmd-color-strip]").innerHTML = '<span class="bmd-placeholder">Loading colors…</span>';
      editor.querySelector("[data-bmd-color-help]").textContent = "Loading colors…";
      try {
        const product = await loadProduct(draft.product);
        renderColors(product);
        if (draft.color) renderSizes(product,draft.color);
      } catch {}
    } else {
      editor.querySelector("[data-bmd-color-strip]").innerHTML = '<span class="bmd-placeholder">Choose a design first</span>';
      editor.querySelector("[data-bmd-color-help]").textContent = "Choose a design first";
      editor.querySelector("[data-bmd-size-row]").innerHTML = '<span class="bmd-placeholder">Choose a color first</span>';
    }

    updateEditorSaveState();
  }

  function closeEditor() {
    if (editor) editor.hidden = true;
    document.documentElement.style.overflow = "";
    activeRoot = null;
    editingShirt = null;
    draft = null;
  }

  function saveEditor() {
    if (!activeRoot || !editingShirt || !draft?.variantId) return;
    const state = getState(activeRoot);
    state.extras[editingShirt] = {...draft};
    renderRootState(activeRoot);
    closeEditor();
  }

  const initRoot = (root) => {
    if (!root || root.dataset.bmdExternalReady === "true") return;
    root.dataset.bmdExternalReady = "true";

    root.querySelectorAll("[data-bmd-additional-id],[data-bmd-additional-qty]").forEach((input) => {
      if (input.name && !input.dataset.bmdOriginalName) input.dataset.bmdOriginalName = input.name;
      input.disabled = true;
      if (input.matches("[data-bmd-additional-id]")) input.value = "";
      input.removeAttribute("name");
    });

    root.querySelectorAll("[data-bmd-qty]").forEach((b) => {
      b.addEventListener("click", () => setQuantity(root,Number(b.dataset.bmdQty || 1)));
    });

    root.querySelectorAll("[data-bmd-edit-extra]").forEach((b) => {
      b.addEventListener("click", () => openEditor(root,Number(b.dataset.bmdEditExtra)));
    });

    const productForm = root.closest("product-form-component");
    const scope = productForm?.closest(".shopify-section, dialog") || productForm;
    scope?.addEventListener("shopify:product:select", (event) => {
      if (!(event.target instanceof Element) || event.target.closest("[data-bmd-bundle-selector]")) return;
      const options = Array.isArray(event.selectedOptions) ? event.selectedOptions : [];
      const summary = root.querySelector("[data-bmd-primary-summary]");
      if (summary && options.length) {
        summary.textContent = root.dataset.currentProductTitle + " · " + options.map((o) => o.value).join(" / ");
      }
      event.promise?.then((result) => {
        const resolved = result?.detail?.resource || result?.variant || null;
        if (resolved) {
          const price = Number(resolved.price);
          if (Number.isFinite(price) && price > 0) root.dataset.primaryPrice = String(price);
          if (typeof resolved.available === "boolean") root.dataset.primaryAvailable = String(resolved.available);
          else if (typeof resolved.availableForSale === "boolean") root.dataset.primaryAvailable = String(resolved.availableForSale);
        }
        renderRootState(root);
      }).catch(() => renderRootState(root));
    });

    renderRootState(root);
  };

  const initAll = (node = document) => {
    if (node.matches?.("[data-bmd-bundle-selector]")) initRoot(node);
    node.querySelectorAll?.("[data-bmd-bundle-selector]").forEach(initRoot);
  };

  initAll(document);
  const observer = new MutationObserver((records) => {
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node.nodeType === 1) initAll(node);
      }
    }
  });
  observer.observe(document.documentElement,{subtree:true,childList:true});
})();